import { ComponentType } from '..';
import ComponentAPI from '../component-api';

type APIInstance = ComponentAPI;

export type Value = boolean | number | object | string | undefined | null;

export interface API {
  new(...args: any[]): APIInstance;
  [key: string]: any;
}

export interface DummyObject {
  [k: string]: Value;
}

export interface ComponentClass {
  new(...args: any[]): unknown;

  propTypes?: DummyObject;
  defaultProps?: DummyObject;
}

class DummyAPI extends ComponentAPI {

}

/**
 * Represents the component information.
 */
class ComponentInfo {

  private name: string;
  private type: ComponentType;
  private component: ComponentClass;
  private api: API;
  private description: string;

  constructor(name: string, type: ComponentType, component: ComponentClass, api: API = DummyAPI, description: string = '') {
    this.name = name;
    this.type = type;
    this.component = component;
    this.api = api;
    this.description = description;
  }

  /**
   * Retrieve the component name.
   *
   * @returns {string}.
   */
  getName(): string {
    return this.name;
  }

  /**
   * Retrieve the component type.
   *
   * @returns {ComponentType}.
   */
  getType(): ComponentType {
    return this.type;
  }

  /**
   * Retrieve the component.
   *
   * @returns {Component} the component.
   */
  getComponent(): ComponentClass {
    return this.component;
  }

  /**
   * Retrieve the component api.
   *
   * @returns {ComponentAPI}
   */
  getAPI(): API {
    return this.api;
  }

  /**
   * Retrieve the component description.
   */
  getDescription(): string {
    return this.description;
  }

  /**
   * Validate the component data.
   *
   * @returns {boolean}
   */
  validate(): void {
    //TODO: validate data
  }

}

export { ComponentInfo as default };
